import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { openModal } from "../../../redux/features/modalSlice";
import { useSelector } from "react-redux";
import Pagination from "../../../common/Pagination";
import Search from "../../../common/Search";
import {
    AiCallList,
    AiCallListByLeadType,
} from "../../../redux/services/Ai Services/Ai.Services";
import { activeLeadType, leadTypeLabel, isHiddenVendorTestLead, vendorCallResultLabel, formatVisitDay, listPageMeta } from "../../../Utils/role";
import SharedPlanBalance from "../../wallet Managment/SharedPlanBalance";

function AllCallList() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [search, setSearch] = useState("");
    const leadType = activeLeadType(searchParams.get("lead_type"));
    const typeLabel = leadTypeLabel(leadType);
    const { refreshData } = useSelector(
        (state) => state.modal
    );
    const [page, setPage] = useState(1);
    const [limit] = useState(100);
    const [callingList, setCallingList] = useState([]);
    const [usage, setUsage] = useState({
        used: 0,
        left: 0,
        limit: 0,
        total: 0,
        callSeconds: 0,
    });
    const [initialLoading, setInitialLoading] = useState(true);

    const [tableLoading, setTableLoading] = useState(false);

    // const [page, setPage] = useState(1);
    // const [limit, setLimit] = useState(5);

    const [totalRoles, setTotalRoles] = useState(0);
    // const [totalPages, setTotalPages] = useState(1);

    // GET LIST
    const fetchRoles = async (pageNo = 1,
        isInitialLoad = false) => {
        try {
            if (isInitialLoad) {
                setInitialLoading(true);
            } else {
                setTableLoading(true);
            }
            // const payload = {
            //     search:search,
            //     page: pageNo,
            //     per_page: limit,
            // };
            const res = leadType
                ? await AiCallListByLeadType(leadType,)
                : await AiCallList();
            const summary = res?.data || {};
            const typedCalls = Array.isArray(summary.leads)
                ? summary.leads
                : Array.isArray(summary.calls)
                    ? summary.calls
                    : Array.isArray(res?.data)
                        ? res.data
                        : [];
            const visibleCalls = (leadType ? typedCalls : (summary.calls || []))
                .filter((item) => !(leadType && isHiddenVendorTestLead(item)));
            setCallingList(visibleCalls);
            const totalLeadSeconds = visibleCalls.reduce(
                (acc, item) => acc + (Number(item.seconds) || 0),
                0
            );
            // const pageMeta = listPageMeta(
            //     res?.total != null || res?.last_page != null ? res : summary,
            //     visibleCalls.length,
            //     limit
            // );
            // ✅ Root aur summary dono ko merge karke bhejenge
            const pageMeta = listPageMeta(
                {
                    ...summary, total:
                        res?.total, last_page:
                        res?.last_page,
                    current_page: res?.current_page
                },
                visibleCalls.length,
                limit
            );
            setUsage({
                used: Number(summary.seconds_used) || 0,
                left: Number(summary.seconds_left) || 0,
                limit: Number(summary.seconds_limit) || 0,
                total: pageMeta.total,
                callSeconds: totalLeadSeconds,
            });
            // setPage(pageMeta.page);
            // setTotalPages(pageMeta.pages);
            // setTotalRoles(pageMeta.total);
            setPage(1);
        } catch (err) {
            console.log(err);
        } finally {
            setInitialLoading(false);
            setTableLoading(false);
        }
    };
    // const handlePageChange = (newPage) => {
    //     if (
    //         newPage >= 1 &&
    //         newPage <= totalPages &&
    //         !tableLoading
    //     ) {
    //         setPage(newPage);
    //         fetchRoles(newPage, false);
    //     }
    // };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };
    // useEffect(() => {
    //   fetchRoles();
    // }, [refreshData]);
    useEffect(() => {
        fetchRoles(1, true);
    }, [refreshData, limit, leadType]);

    const filteredList = useMemo(() => {
        if (!search.trim()) return callingList;
        const q = search.trim().toLowerCase();
        return callingList.filter((item) =>
            [item.name, item.phone, item.status, item.lead_status, item.called_at]
                .filter(Boolean)
                .join(" ")
                .toLowerCase()
                .includes(q)
        );
    }, [callingList, search]);

    // 2️⃣ Total pages calculate
    const totalPages = Math.max(1, Math.ceil(filteredList.length / limit));

    // 3️⃣ Current page ki rows
    const pagedList = useMemo(() => {
        const start = (page - 1) * limit;
        return filteredList.slice(start, start + limit);
    }, [filteredList, page, limit]);

    if (initialLoading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary"></div>
            </div>
        );
    }
    // const filteredList = callingList.filter((item) => {
    //     if (!search.trim()) return true;
    //     const q = search.trim().toLowerCase();
    //     return [item.name, item.phone, item.status, item.lead_status, item.called_at]
    //         .filter(Boolean)
    //         .join(" ")
    //         .toLowerCase()
    //         .includes(q);
    // });



    // 1️⃣ Filter (search ke hisaab se)

    return (
        <div>
            <div className="d-flex  align-items-center justify-content-between page-header-breadcrumb">
                <div className="title_member">
                    <h4>{typeLabel ? `${typeLabel} Calling History` : "All Calling List"}</h4>
                    <nav className="page-breadcrumb">
                        <Link to="/">Home</Link>
                        <span className="mx-2">/</span>
                        <span>{typeLabel ? `${typeLabel} Calling History` : "All Calling List"}</span>
                    </nav>
                </div>

                {/* <button
          className="add-btn"
          onClick={() =>
            dispatch(
              openModal({
                type: "add-role",
                title: "Add Role",
                data: null,
                onSuccess: fetchRoles,
              })
            )
          }
        >
          Add Role
        </button> */}


            </div>
            <div className="main_page">
                {leadType && (
                    <div className="row g-3 mb-3">
                        <div className="col-12 col-lg-9">
                            <div className="st-wrapper-card p-3 text-start">
                                <SharedPlanBalance plan={usage} />
                            </div>
                        </div>
                        <div className="col-12 col-lg-3">
                            <div className="st-wrapper-card p-3 text-start">
                                <div className="text-muted">Calls in this list</div>
                                <h4 className="mb-0">{usage.total.toLocaleString("en-IN")}</h4>
                            </div>
                        </div>
                    </div>
                )}
                {/* {totalPages > 1 && (
    <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-3">
        <Search
            search={search}
            placeholder="Search ..."
            onSearch={(value) => {
                setSearch(value);
                setPage(1);
            }}
        />
        <Pagination
            page={page}
            totalPages={totalPages}
            onPageChange={handlePageChange}
        />
    </div>
)} */}





                <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-3">
                    <Search
                        search={search}
                        placeholder="Search ..."
                        onSearch={(value) => {
                            setSearch(value);
                            setPage(1);
                        }}
                    />
                    {/* {totalPages > 1 && ( */}
                    <Pagination
                        page={page}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                    {/* )} */}
                </div>




                <div className="st-wrapper-card text-center">
                    <div className="st-table-responsive">
                        <table className="table st-custom-table align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>Sr.No</th>
                                    {leadType && <th>Name</th>}
                                    <th>Mobile</th>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Duration</th>
                                    <th>Status</th>
                                    {leadType && <th>Call Result</th>}
                                    {leadType && <th>Visit</th>}
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {/* {tableLoading ? (
                                    <tr>
                                        <td colSpan={leadType ? 10 : 8} className="text-center">
                                            Loading...
                                        </td>
                                    </tr>
                                ) : pagedList.length > 0 ? ( */}
                                {pagedList.length > 0 ? (
                                    pagedList.map((item, index) => {
                                        const srNo = (page - 1) * limit + index + 1;
                                        return (
                                            <tr key={item.lead_id || index}>
                                                <td>{srNo}</td>
                                                {leadType && <td>{item.name || "-"}</td>}
                                                <td>{item?.phone || "-"}</td>
                                                <td>{item.called_at ? item.called_at.split(" ")[0] : "-"} </td>
                                                <td>{item.called_at ? item.called_at.split(" ")[1] : "-"} </td>
                                                <td>{leadType ? formatCallSeconds(item.seconds) : (item.seconds || "0s")}</td>
                                                <td>
                                                    <span className="crm-status-badge">
                                                        {leadType
                                                            ? vendorCallResultLabel(item.status)
                                                            : (item.status ? item.status.replaceAll("_", " ") : "-")}
                                                    </span>
                                                </td>
                                                {leadType && (
                                                    <td>
                                                        <span className="crm-status-badge">
                                                            {vendorCallResultLabel(item.lead_status)}
                                                        </span>
                                                    </td>
                                                )}
                                                {leadType && (
                                                    <td>{formatVisitSlot(item.visit_date, item.visit_time)}</td>
                                                )}
                                                <td>
                                                    <div className="d-flex align-items-center justify-content-center gap-1">
                                                        <button
                                                            className="st-action-btn st-view-btn"
                                                            onClick={() => {
                                                                const cleanPhone = (item.phone || "").replace(/\D/g, "").slice(-10);
                                                                navigate(`/view-call-detail/${cleanPhone}`);
                                                            }}
                                                        >
                                                            <FaEye />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={leadType ? 10 : 8} className="text-center">
                                            No Calling list Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                        {totalPages > 1 && (
                            <div className="d-flex justify-content-end mt-3">
                                <Pagination
                                    page={page}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>

        </div>
    );
}

function formatVisitSlot(date, time) {
    if (!date && !time) return "-";
    return [formatVisitDay(date), time].filter(Boolean).join(" ");
}

function formatCallSeconds(value) {
    const total = Number(value) || 0;
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    if (hours > 0) return `${hours}h ${minutes}m ${seconds}s`;
    if (minutes > 0) return `${minutes}m ${seconds}s`;
    return `${seconds}s`;
}

export default AllCallList;